<template>
    <div>
        <s-crud ref="ExtDelivery" title="Entregas" :config="config" :filter="filter" search-input
            @rowSelected="rowSelected($event)" height="450" :pdf="form.DocEntryDelivered !== null" @pdf="printPDF()">
            <template v-slot:filter>
                <v-container>
                    <v-row>
                        <!-- <v-col cols="4" md="4">
                            <s-select-campaign-se label="Campaña" v-model="CmpID"
                                @datesLoaded="onCampaignDatesLoaded" />
                        </v-col> -->
                        <v-col cols="4" md="4">
                            <s-date label="Fecha inicio" v-model="filter.DocDateBegin"></s-date>
                        </v-col>
                        <v-col cols="4" md="4">
                            <s-date label="Fecha fin" v-model="filter.DocDateEnd"></s-date>
                        </v-col>
                    </v-row>
                </v-container>
            </template>
        </s-crud>

        <AlertSunshine :dialog="loading" />

        <!-- Modal Impresión PDF -->
        <v-dialog v-if="showDialog" v-model="showDialog" width="210mm" persistent>
            <DeliveryIQFPDF v-if="form.U_SYP_AREAPROD == 'IQF'" :form="form" @close="showDialog = false" />
            <DeliveryPDF v-else :form="form" @close="showDialog = false" />
        </v-dialog>
    </div>
</template>

<script>
import _service from "@/services/ExternalTrade/ExtDeliveryService.js";
import DeliveryPDF from "./DeliveryPDF.vue";
import DeliveryIQFPDF from "./DeliveryIQFPDF.vue";

export default {
    components: { DeliveryPDF, DeliveryIQFPDF },
    data() {
        return {
            config: {
                model: {
                    DocEntry: 'ID',
                    // DATE: 'date',
                    // U_SYP_ETD: 'date',
                    // U_SYP_ETA: 'date'
                },
                service: _service,
                headers: [
                    { text: 'DocEntry', value: 'DocEntry' },
                    { text: 'DocEntry2', value: 'DocEntryDelivered' },
                    { text: 'N° Documento', value: 'DOCNUM' },
                    { text: 'Fecha', value: 'DATE' },
                    // { text: 'Cod. Cliente', value: 'CardCode' },
                    { text: 'CUSTOMER', value: 'CUSTOMER', width: '200px' },
                    { text: 'POD', value: 'POD' },
                    { text: 'VESSEL & VOYAGE', value: 'VESSEL_VOYAGE', width: '160px' },
                    // { text: 'VOYAGE', value: 'U_SYP_VIAJE' },
                    { text: 'BOOKING', value: 'BOOKING' },
                    { text: 'CONTAINER Nº', value: 'CONTAINER_N' },
                    { text: 'BRAND', value: 'MARK' },
                    { text: 'VARIETY', value: 'VARIETY' },
                    { text: 'COMMODITY', value: 'COMMODITY', width: '160px' },
                    { text: 'STICKERS', value: 'STICKERS' },
                    { text: 'SUNSHINE SEALS', value: 'SUNSHINE_SEALS', width: '160px' },
                    { text: 'CUSTOMS SEAL', value: 'CUSTOMS_SEAL', width: '100px' },
                    { text: 'NET WEIGHT', value: 'NET_WEIGHT', width: '90px', align: 'center' },
                    { text: 'GROSS WEIGHT', value: 'GROSS_WEIGHT', width: '100px', align: 'center' },
                    { text: 'TEMPERATURE', value: 'TEMPERATURE', width: '100px', align: 'center' },
                    // { text: 'TEMPERATURE RECORDER N°', value: 'U_SUN_TERMO1', width: '160px', align: 'center' },
                    { text: 'QUANTITY', value: 'QUANTITY', width: '70px', align: 'center' },
                    { text: 'ETD', value: 'ETD', width: '100px', align: 'center' },
                    { text: 'ETA', value: 'ETA', width: '100px', align: 'center' },
                    { text: 'QUANTITY OF FILTERS', value: 'U_SYP_FILTROS', width: '100px', align: 'center' },
                    { text: 'VENTILATION (CBM/CBH)', value: 'VENTILATION', align: 'center' },
                    { text: 'CONTROLLED ATMOSPHERE', value: 'ATMOSPHERE', align: 'center' },
                    { text: 'OXYGEN (% 02)', value: 'OXYGEN', align: 'center' },
                    { text: 'CARBON DIOXIDE (% CO2)', value: 'DIOXIDE', align: 'center' },
                    { text: 'AREA DE PRODUCCIÓN', value: 'U_SYP_AREAPROD', align: 'center' },
                ]
            },
            filter: {
                DocDateBegin: null,
                DocDateEnd: null
            },
            loading: false,
            form: {},
            formDetails: [],
            formPallets: [],
            formSummary: [],
            showDialog: false,
            CmpID: 0,
        }
    },
    methods: {
        rowSelected(rows) {
            if (rows.length > 0) {
                this.form = rows[0];
            }
        },
        async printPDF() {
            await this.getFormPallets();
            this.showDialog = true;
        },
        async getFormPallets() {
            this.loading = true;
            try {
                const UsrCreateID = this.$fun.getUserID();
                const response = await _service.pallets({ DocEntry: this.form.DocEntryDelivered }, UsrCreateID);
                // console.log(response);
                if (response.status == 200) {
                    console.log("Pallets", response.data)
                    // this.formDetails = response.data;
                    this.form = { ...this.form, DeliveryPallets: response.data }
                } else {
                    this.form = { ...this.form, DeliveryPallets: [] }
                    this.$fun.alert("Error al cargar pallets de entrega", "warning");
                }
                await this.getFormSummary();
                this.loading = false;
            } catch (error) {
                this.form = { ...this.form, DeliveryPallets: [] }
                this.loading = false;
                this.$fun.alert("Error al cargar pallets de entrega", "warning");
                console.log(error);
            }
        },
        async getFormSummary() {
            this.loading = true;
            try {
                const UsrCreateID = this.$fun.getUserID();
                const response = await _service.summary({ DocEntry: this.form.DocEntryDelivered }, UsrCreateID);
                if (response.status == 200) {
                    console.log("Summary", response.data)
                    // this.formDetails = response.data;
                    let DeliverySummary = []
                    if (response.data.length > 0) {
                        for (const summary of response.data) {
                            const details = await this.getFormDetails(summary.SUMMARY);
                            DeliverySummary.push({ ...summary, DeliveryDetails: details });
                        }
                    }
                    this.form = { ...this.form, DeliverySummary }
                } else {
                    this.form = { ...this.form, DeliverySummary: [] }
                    this.$fun.alert("Error al cargar resumen de entrega", "warning");
                }
                this.loading = false;
            } catch (error) {
                this.form = { ...this.form, DeliverySummary: [] }
                this.loading = false;
                if (error.response) {
                    this.$fun.alert(error.response.data.Message, "error");
                } else if (error.request) {
                    this.$fun.alert("No hubo respuesta del servidor", "error");
                } else {
                    this.$fun.alert("Error al cargar resumen de entrega: " + error.message, "error");
                }
                console.log("Error al cargar resumen de entrega :", error);
            }
        },
        async getFormDetails(Sumary) {
            this.loading = true;
            try {
                const UsrCreateID = this.$fun.getUserID();
                let params = { DocEntry: this.form.DocEntryDelivered };
                if (Sumary == null || Sumary == undefined) {
                } else {
                    params.Sumary = Sumary;
                }

                const response = await _service.detail(params, UsrCreateID);
                this.loading = false;
                if (response.status == 200) {
                    console.log("Details", response.data)
                    return response.data
                } else {
                    this.$fun.alert("Error al cargar detalle de entrega", "warning");
                    return []
                }
            } catch (error) {
                this.loading = false;
                this.$fun.alert("Error al cargar detalle de entrega", "warning");
                console.log("Error al cargar detalle de entrega :", error);
                return []
            }
        }
    },

}
</script>